import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=6405bb1c&scoped=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=ts"
export * from "./GlobalSearch.vue?vue&type=script&lang=ts"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=6405bb1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405bb1c",
  null
  
)

export default component.exports